import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'loyaltic-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showNavigation = true;
  isCollapsed = true;
  isLoggedIn = false;
  private routerSubscription?: Subscription;
  private currentUrl = '';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public router: Router,
    public authService: AuthService
  ) { }

  ngOnInit() {
    this.isLoggedIn = this.authService.IsLoggedIn();
    this.currentUrl = this.stripUrl(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = this.stripUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  get isLandingPage(): boolean {
    return this.currentUrl === '' || this.currentUrl === '/';
  }

  onRewardsClick(event: Event): void {
    event.preventDefault();
    this.isCollapsed = true;

    const currentPath = this.router.url.split('#')[0];
    if (currentPath === '' || currentPath === '/') {
      this.scrollRewardsIntoView();
      return;
    }

    this.router.navigate(['/'], { fragment: 'rewards-section' });
  }

  private scrollRewardsIntoView(): void {
    const target =
      this.document.getElementById('rewards-section') ??
      this.document.getElementById('rewardsCarousel');

    if (!target) {
      return;
    }

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  logout() {
    this.isLoggedIn = false;
    this.authService.logout();
  }

  navigateHome(event: Event): void {
    event.preventDefault();
    this.isCollapsed = true;
    if (this.isLandingPage) {
      this.scrollTop();
      return;
    }
    this.router.navigate(['/']);
  }

  private scrollTop(): void {
    this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private stripUrl(url: string): string {
    return url.split('?')[0].split('#')[0];
  }
}
